import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Form, Select, Modal, DatePicker } from 'antd';

import * as sharedActions from '../../../../shared/store/actions';

import { renderNoDataOrSpinner } from '../../../../shared/utils';

import '../../styles.less';

let agentFieldTimeout;

const EndorsementStatusChangeModal = ({ modalState, rootContainer, resetColumns, changeStatus }) => {
  const dispatch = useDispatch();
  const [changeEndorsementStatusForm] = Form.useForm();

  const agentsLookup = useSelector((state) => state.shared.agentsLookup);
  const agentsLookupLoading = useSelector((state) => state.shared.agentsLookupLoading);
  const endorsementStatuses = useSelector((state) => state.endorsementsPipelines.endorsementStatuses);
  const endorsementStatusesLoading = useSelector((state) => state.endorsementsPipelines.endorsementStatusesLoading);
  const endorsementStatusChangeLoading = useSelector((state) => state.endorsementsPipelines.endorsementStatusChangeLoading);

  const handleOk = () => {
    changeEndorsementStatusForm.validateFields().then((values) => {
      const formData = values;
      formData.id = modalState.itemToEdit.id;

      changeStatus(formData);
      changeEndorsementStatusForm.resetFields();
    });
  };

  const handleCancel = () => {
    changeEndorsementStatusForm.resetFields();
    resetColumns();
  };

  const handleSearchAgent = (searchString) => {
    if (agentFieldTimeout) {
      clearTimeout(agentFieldTimeout);
      agentFieldTimeout = null;
    }

    agentFieldTimeout = setTimeout(() => dispatch(sharedActions.getAgentsLookup({ pageSize: 15, pageNumber: 1, searchString: searchString })), 500);
  };

  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
  };

  const formRootContainer = () => document.getElementById('change-endorsement-status-form');

  return (
    <Modal
      title="Change status/follow up person/date"
      open={modalState.visible}
      onOk={handleOk}
      onCancel={handleCancel}
      getContainer={rootContainer}
      width={600}
      confirmLoading={endorsementStatusChangeLoading}
      okButtonProps={{ disabled: endorsementStatusChangeLoading }}
    >
      <Form
        {...layout}
        form={changeEndorsementStatusForm}
        size="small"
        layout="horizontal"
        className="modal-form"
        id="change-endorsement-status-form"
      >
        <Form.Item name={['followUpDate']} label={'Follow Up Date'}>
          <DatePicker
            style={{ width: '100%' }}
            size="small"
            format={'MM/DD/YYYY'}
            getPopupContainer={formRootContainer}
            placeholder="Please pick a date"
          />
        </Form.Item>

        <Form.Item
          name={['newStatus']}
          label="Status"
          initialValue={modalState.status}
          rules={[{ required: true, message: 'Status field is required' }]}
        >
          <Select
            showArrow
            loading={endorsementStatusesLoading}
            getPopupContainer={formRootContainer}
            placeholder="Please Select Status"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            disabled={true}
          >
            {endorsementStatuses && endorsementStatuses.length
              ? endorsementStatuses.map((status) => (
                  <Select.Option value={status.value} key={status.value}>
                    {status.name}
                  </Select.Option>
                ))
              : null}
          </Select>
        </Form.Item>

        <Form.Item name={['followUpPersonId']} label={'Follow Up Person'}>
          <Select
            allowClear
            showSearch
            showArrow
            loading={agentsLookupLoading}
            filterOption={false}
            getPopupContainer={rootContainer}
            placeholder="Select Follow Up Person"
            onSearch={handleSearchAgent}
            notFoundContent={renderNoDataOrSpinner(agentsLookupLoading)}
          >
            {agentsLookup && agentsLookup.dataList.length
              ? agentsLookup.dataList.map((agent) => (
                  <Select.Option value={agent.key} key={agent.key}>
                    {agent.value}
                  </Select.Option>
                ))
              : null}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EndorsementStatusChangeModal;
